import { PlayerConfig } from '../../../../services/course-player.service';

/**
 * Pure function: compute the next `previewUnlocked` state + player config
 * when the instructor toggles the unlock button in instructor_preview mode.
 *
 * - When currently locked, returns an unlocked config (no enforcement, jump
 *   navigation allowed) and stashes the previous config for later restore.
 * - When currently unlocked, returns the stashed locked config.
 * - Returns `null` when the toggle should be a no-op (wrong mode, or no
 *   stashed config to restore).
 */
export interface PreviewUnlockInput {
  playerMode: string;
  playerConfig: PlayerConfig;
  previewUnlocked: boolean;
  lockedPlayerConfig: PlayerConfig | null;
}

export interface PreviewUnlockResult {
  playerConfig: PlayerConfig;
  previewUnlocked: boolean;
  lockedPlayerConfig: PlayerConfig | null;
}

export function togglePreviewUnlockState(
  input: PreviewUnlockInput
): PreviewUnlockResult | null {
  if (input.playerMode !== 'instructor_preview') return null;

  if (!input.previewUnlocked) {
    return {
      playerConfig: {
        ...input.playerConfig,
        enforceSequential: false,
        enforceVideoCompletion: false,
        allowJumpNavigation: true
      },
      previewUnlocked: true,
      lockedPlayerConfig: input.playerConfig
    };
  }

  if (input.lockedPlayerConfig) {
    return {
      playerConfig: input.lockedPlayerConfig,
      previewUnlocked: false,
      lockedPlayerConfig: null
    };
  }

  return null;
}
